import React, { Component } from 'react';
import { URLImgFront } from '../../../../config/URLDB';

class FileUploader extends Component {
    form = React.createRef();
    constructor(props) {
        super(props);

        this.state = {
            active: false,
            imageSrc: "",
            imageName: "",
            image: [],
            loaded: false
        };

        this.onDragEnter = this.onDragEnter.bind(this);
        this.onDragLeave = this.onDragLeave.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onFileChange = this.onFileChange.bind(this);
    }

    componentDidMount() {
        this.setState({
            imageName: this.props.nombreModal
        });
    }

    onDragEnter(e) {
        this.setState({ active: true });
    }

    onDragLeave(e) {
        this.setState({ active: false });
    }

    onDragOver(e) {
        e.preventDefault();
    }

    onDrop(e) {
        e.preventDefault();
        this.setState({ active: false });
        this.onFileChange(e, e.dataTransfer.files[0]);
    }

    onFileChange(e, files) {
        var file = files || e.target.files[0],
            pattern = /image-*/,
            reader = new FileReader();
        if (file === undefined || file.name === null) {
            return;
        } else {
            if (!file.type.match(pattern)) {
                alert("Formato inválido");
                return;
            }
            
            this.setState({ loaded: false });
            reader.onload = e => {
                this.setState({
                    imageSrc: reader.result,
                    loaded: true,
                    imageName: file.name
                });
            };
            reader.readAsDataURL(file);
            this.props.FCambiar(file.name, reader.result);
        }
    }

    getFileName() {
        return this.state.imageName;
    }
    getFileObject() {
        return this.refs.input.files[0];
    }

    getFileString() {
        return this.state.imageSrc;
    }

    render() {
        //RQTO. LANDING PAGE - UNIDAD DE SEGUROS - FASE II AMPG 
        const { imageSrc, imageName } = this.state;
        const { ruta, estadoImg, nombreImg = null } = this.props;
        const urlimagen = estadoImg ? imageSrc : `${URLImgFront}/assets/${ruta}`;
        const alternativa = estadoImg ? imageSrc : ruta;
        const nombarchivo = (imageName || nombreImg) || 'No se ha seleccionado ninguna imagen...';
        const campoarchivo = <form name="form" ref={this.formRef} id="form">
            <div className="row justify-content-center" onDragEnter={this.onDragEnter} onDragLeave={this.onDragLeave} onDragOver={this.onDragOver} onDrop={this.onDrop}>
                <div className="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-12">
                    <img className="img-fluid py-4" style={{ height: '400px' }} src={urlimagen} alt={alternativa} /><br />
                    <div className="form-group">
                        <div className="custom-file">
                            <input type="file" accept="image/*" onChange={this.onFileChange} ref="input" className="custom-file-input" id="imagenseg" name="imagenseg" />
                            <label className="custom-file-label text-truncate mt-1 text-left" htmlFor="imagenseg">
                                {nombarchivo}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <p style={{ color: 'gray' }}>Resolución definida: Altura 656px, Formato: JPG</p>
        </form>;
        return campoarchivo;
    }
}

export default FileUploader;
